import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import PropTypes from 'prop-types';
import { FiChevronDown } from 'react-icons/fi';

import ContainerPropTypes from '../../proptypes/container';
import MilestonesPropTypes from '../../proptypes/milestones';
import ScoreMetrics from '../common/ScoreMetrics';
import TotalScoreConsumption from '../common/TotalScoreConsumption';
import ContainerStats from './ContainerStats';
import ContainerTitle from './ContainerTitle';

const ContainerAccordion = ({
    container,
    containerReference,
    milestones,
    defaultExpanded,
    disabled,
}) => {
    return (
        <Accordion
            key={container.id}
            defaultExpanded={defaultExpanded}
            sx={{
                minWidth: {
                    lg: '700px',
                },
                backgroundColor: 'white !important',
            }}
            disabled={disabled}
        >
            <AccordionSummary
                expandIcon={<FiChevronDown />}
                aria-controls={`${container.id}-content`}
                id={`${container.id}-header`}
                sx={{ opacity: '1 !important' }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: { xs: 'flex-start', md: 'space-between' },
                        flexDirection: { xs: 'column', md: 'row' },
                        marginRight: 2,
                    }}
                >
                    <ContainerTitle name={container.name} type={container.type} />
                    <Box
                        sx={{
                            minWidth: '320px',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            '&>*:nth-of-type(2)': {
                                marginLeft: 2,
                            },
                        }}
                    >
                        <TotalScoreConsumption
                            score={container.score}
                            scoreReference={containerReference?.score}
                        />
                    </Box>
                </Box>
            </AccordionSummary>
            <AccordionDetails
                sx={{
                    flexDirection: 'column',
                    position: 'relative',
                }}
            >
                <Box>
                    <ScoreMetrics
                        score={container.score}
                        scoreReference={containerReference?.score}
                    />
                </Box>
                <Box>
                    {container.stats && (
                        <Box>
                            <ContainerStats
                                stats={container.stats}
                                statsReference={containerReference?.stats}
                                milestones={milestones}
                            />
                        </Box>
                    )}
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

ContainerAccordion.propTypes = {
    container: ContainerPropTypes,
    containerReference: ContainerPropTypes,
    milestones: MilestonesPropTypes,
    expanded: PropTypes.bool,
    disabled: PropTypes.bool,
    defaultExpanded: PropTypes.bool,
};
export default ContainerAccordion;
